import styles from './PlacingOrderTab.module.scss';
import cn from 'classnames';
import { IPlacingOrderTabProps } from '../../types';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';

const PlacingOrderTab: React.FC<IPlacingOrderTabProps> = (props: IPlacingOrderTabProps): React.ReactElement => {
  const { handlerOnClick, quantity, selected, title } = props;

  return (
      <button
          className={cn(styles.tab, selected && styles.tabSelected)}
          onClick={handlerOnClick}
      >
        <Text
            color={TextColor.BLUE}
            size={TextSize.M}
            weight={TextWeight.MEDIUM}
        >
          {title}
        </Text>
        {quantity && (
            <div className={styles.tabCounter}>
              <Text
                  color={TextColor.WHITE}
                  size={TextSize.S}
                  weight={TextWeight.MEDIUM}
              >
                {quantity}
              </Text>
            </div>
        )}
      </button>
  );
};

export default PlacingOrderTab;